import React from 'react';

// material-ui
import { Box, Button, Typography, useMediaQuery, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';

// project imports
import AnimateButton from 'ui-component/extended/AnimateButton';
import constants from '../../../../constants';
import { useLanguage } from '../../../../context/LanguageContext';

// style constant
const useStyles = makeStyles((theme) => ({
  card: {
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '18px',
    padding: '18px',
    background: 'linear-gradient(145deg, rgba(8, 30, 63, 0.94) 0%, rgba(13, 91, 180, 0.92) 48%, rgba(112, 70, 210, 0.92) 100%)',
    color: theme.palette.common.white,
    border: '1px solid rgba(255, 255, 255, 0.28)',
    boxShadow: '0 18px 44px rgba(15, 73, 132, 0.24)',
    '&:before': {
      content: '""',
      position: 'absolute',
      width: '118px',
      height: '118px',
      right: '-42px',
      top: '-42px',
      borderRadius: '50%',
      background: 'rgba(255, 255, 255, 0.18)'
    },
    '&:after': {
      content: '""',
      position: 'absolute',
      width: '86px',
      height: '86px',
      left: '-34px',
      bottom: '-38px',
      borderRadius: '50%',
      background: 'rgba(24, 201, 139, 0.24)'
    },
    [theme.breakpoints.down('sm')]: {
      borderRadius: '14px',
      padding: '16px'
    }
  },
  content: {
    position: 'relative',
    zIndex: 1
  },
  eyebrow: {
    display: 'inline-flex',
    alignItems: 'center',
    minHeight: '24px',
    padding: '4px 10px',
    borderRadius: '999px',
    background: 'rgba(255, 255, 255, 0.16)',
    color: 'rgba(255, 255, 255, 0.92)',
    fontSize: '0.68rem',
    fontWeight: 800,
    letterSpacing: '0.04em',
    textTransform: 'uppercase'
  },
  title: {
    marginTop: '12px',
    color: theme.palette.common.white,
    fontWeight: 900,
    lineHeight: 1.15,
    letterSpacing: 0
  },
  description: {
    marginTop: '8px',
    color: 'rgba(255, 255, 255, 0.78)',
    lineHeight: 1.45
  },
  button: {
    width: '100%',
    minHeight: '42px',
    marginTop: '16px',
    borderRadius: '12px',
    color: '#12305c',
    background: theme.palette.common.white,
    fontWeight: 900,
    textTransform: 'none',
    boxShadow: '0 12px 24px rgba(4, 16, 35, 0.22)',
    '&:hover': {
      background: 'rgba(255, 255, 255, 0.92)',
      boxShadow: '0 16px 30px rgba(4, 16, 35, 0.28)'
    }
  }
}));

// ===========================|| SIDEBAR - UPGRADE PLAN CARD ||=========================== //

const UpgradePlanCard = () => {
  const classes = useStyles();
  const theme = useTheme();
  const matchDownSm = useMediaQuery(theme.breakpoints.down('sm'));
  const { t } = useLanguage();
  const labelJoin = t('labelJoin');
  const labelJoinPremium = t('labelJoinPremium');
  const upCTAlabel = t('upCTAlabel');
  const upCTAPrice = t('upCTAPrice');
  const upgradeNowLabel = t('upgradeNowLabel', 'Upgrade now');

  const handleUpgrade = () => {
    window.location.href = constants.premium.endpoint;
  };

  return (
    <Box className={classes.card}>
      <Box className={classes.content}>
        <Typography component="p" className={classes.eyebrow}>
          {upgradeNowLabel}
        </Typography>
        <Typography variant={matchDownSm ? 'h4' : 'h3'} className={classes.title}>
          {labelJoinPremium}
        </Typography>
        <Typography variant="body2" className={classes.description}>
          {upCTAlabel}. {upCTAPrice}
        </Typography>
        <AnimateButton>
          <Button className={classes.button} onClick={handleUpgrade} disableElevation>
            {labelJoin}
          </Button>
        </AnimateButton>
      </Box>
    </Box>
  );
};

export default UpgradePlanCard;
